import { postAcademyEvents } from "./academyApi";

let sessionId = null;
const queue = [];
let flushTimer = null;
let cachedClient = null;

function getSessionId() {
  if (sessionId) return sessionId;
  try {
    sessionId = sessionStorage.getItem("qt_academy_session");
    if (!sessionId) {
      sessionId = `as_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
      sessionStorage.setItem("qt_academy_session", sessionId);
    }
  } catch {
    sessionId = `as_${Date.now()}`;
  }
  return sessionId;
}

function detectDeviceClass() {
  if (typeof window === "undefined") return "desktop";

  const ua = navigator.userAgent || "";
  const width = window.innerWidth || 0;

  if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (width >= 768 && width < 1024)) {
    return "tablet";
  }
  if (/Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) || width < 768) {
    return "mobile";
  }
  return "desktop";
}

export function getClientContext() {
  if (cachedClient) return cachedClient;
  if (typeof window === "undefined") return {};

  const conn =
    navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const deviceClass = detectDeviceClass();

  cachedClient = {
    device_class: deviceClass,
    viewport_w: window.innerWidth || null,
    viewport_h: window.innerHeight || null,
    screen_w: window.screen?.width || null,
    screen_h: window.screen?.height || null,
    dpr: window.devicePixelRatio || null,
    connection: conn?.effectiveType || null,
    downlink_mbps: typeof conn?.downlink === "number" ? conn.downlink : null,
    rtt_ms: typeof conn?.rtt === "number" ? conn.rtt : null,
    save_data: conn?.saveData === true,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
    language: navigator.language || null,
    standalone: window.matchMedia?.("(display-mode: standalone)")?.matches === true,
  };

  return cachedClient;
}

function getPlatformLabel() {
  const deviceClass = getClientContext().device_class || detectDeviceClass();
  if (deviceClass === "mobile") return "web-mobile";
  if (deviceClass === "tablet") return "web-tablet";
  return "web-desktop";
}

export function trackAcademyEvent(event_type, payload = {}) {
  const client = getClientContext();
  queue.push({
    event_type,
    payload: { ...payload, client },
    session_id: getSessionId(),
    platform: getPlatformLabel(),
    module_id: payload.module_id || null,
    lesson_id: payload.lesson_id || null,
  });
  if (!flushTimer) {
    flushTimer = setTimeout(flushAcademyEvents, 2000);
  }
}

export async function flushAcademyEvents() {
  flushTimer = null;
  if (!queue.length) return;
  const batch = queue.splice(0, 50);
  try {
    await postAcademyEvents(batch);
  } catch {
    queue.unshift(...batch);
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flushAcademyEvents();
  });
}
